let variable1Value: any = null;
export let globalObject = { 
  variable1: variable1Value 
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/utils/proxyDataUtil.ts